import { TELEGRAM_MINI_APP_URL } from '../config';

export function Hero() {
  return (
    <section className="relative pt-24 pb-20 sm:pt-32 sm:pb-28 px-4 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-tea-100/30 to-transparent pointer-events-none" />
      <div className="absolute top-20 right-0 w-72 h-72 rounded-full bg-tea-200/20 blur-3xl" />
      <div className="absolute bottom-10 left-0 w-48 h-48 rounded-full bg-tea-300/10 blur-2xl" />

      <div className="relative max-w-4xl mx-auto text-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-tea-900 tracking-tight leading-tight">
          Премиальный чай оптом
          <br />
          <span className="text-tea-600">прямо из Китая</span>
        </h1>
        <p className="mt-6 text-lg sm:text-xl text-tea-600 max-w-2xl mx-auto leading-relaxed">
          Более 100 сортов чая, улунов и травяных сборов. Минимальный заказ от 5 кг. 
          Оптовые цены без посредников. Заказ через Telegram за 2 минуты.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href={TELEGRAM_MINI_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-tea-700 text-white font-semibold hover:bg-tea-800 transition-all shadow-lg shadow-tea-700/20 hover:shadow-xl hover:scale-105"
          >
            <span className="text-xl">🛒</span>
            Открыть каталог в Telegram
          </a>
          <a
            href="#catalog"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl border-2 border-tea-300 text-tea-700 font-semibold hover:bg-tea-50 transition-colors"
          >
            Смотреть каталог
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </a>
        </div>
        <div className="mt-8 flex flex-wrap justify-center gap-6 text-sm text-tea-500">
          <div className="flex items-center gap-2">
            <span className="text-tea-400">✓</span>
            <span>Без регистрации</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-tea-400">✓</span>
            <span>От 5 кг</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-tea-400">✓</span>
            <span>Доставка по России</span>
          </div>
        </div>
      </div>
    </section>
  );
}
